/**
 * Vuex module for branding configuration.
 */
import debug from 'debug'
import API from '@/api'

const dbg = debug('store:action:branding:')

const actions = {
  async initBranding ({ commit }) {
    dbg('Init branding')
    try {
      const response = await API.getBranding()
      commit('SET_BRANDING', response.data)
    } catch (error) {
      dbg('Failed to initialize branding: %o', error)
    }
  }
}

const mutations = {
  SET_BRANDING (state, data) {
    state.logo = data.logo
    state.userAgent = data.user_agent
    state.platformName = data.platform_name
    state.displayCopyright = data.display_copyright === '1'
  }
}

const state = {
  logo: '',
  userAgent: '',
  platformName: '',
  displayCopyright: false
}

const getters = {
  displayCopyright: state => state.displayCopyright
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
